import React from "react";
import { GoogleMap, useJsApiLoader , Marker , GoogleMapsMarkerClusterer} from '@react-google-maps/api';
const containerStyle = {
  width: '544px',
  height: '250px'
};

const center = {
  lat: 33.650444862090815,
  lng: 72.9776038
   
};
function Maps() {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: "AIzaSyA-TjJlORUK_AYyE1N2szdAVKNJ3n_KkZw"
  })

  const [map, setMap] = React.useState(null)

  const onLoad = React.useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    map.fitBounds(bounds);
    setMap(map)
  }, [])

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null)
  }, [])

  return isLoaded ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={20}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        <Marker  zoom={200} position={{ lat: 33.650444862090815, lng: 72.9776038 }} />
        
        { /* Child components, such as markers, info windows, etc. */ }
      </GoogleMap>
  ) : <></>
}
export default Maps;